<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Terms And Conditions</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">Terms And Conditions</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<!-- Account-Page -->
	<Seller v-if="type == 'seller'" />
	<Buyer v-if="type == 'buyer'" />
	<Checkout v-if="type == 'checkout'" />
	<!-- Account-Page /- -->
	<Footer />
</template>

<script>
	import Footer from "../components/Bottom/Footer.vue";
	import Seller from "../components/TermsAndConditions/Seller.vue";
	import Buyer from "../components/TermsAndConditions/Buyer.vue";
	import Checkout from "../components/TermsAndConditions/Checkout.vue";
	export default {
		components: {Footer, Seller, Buyer, Checkout},
		data() {
			return {
				type: null,
			};
		},
		mounted() {
			const type = this.$route.query.type;
			if (!type || (type != "seller" && type != "buyer" && type != "checkout")) {
				this.$router.push({name: "404"});
			}
			this.type = type;
			console.log("Auth Vue Mounted");
			const el = document.getElementsByClassName("page-style-a")[0];
			this.$smoothScroll({
				scrollTo: el, // scrollTo is also allowed to be number
			});
		},
	};
</script>

<style></style>
